import React, { Component } from "react";
import PrintPreview from "../PrintPreview";
import ReportStore from "stores/ReportStore";
import "./Print.css";

const DEFAULT_ROW = 51;
class PrintReportAnalysisWorkDebitCreditInOut extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      loading: false,
      dataList: [],
      data: [],
      report_title: "กำลังดึงข้อมูล..",
    };

    var cssPagedMedia = (function () {
      var style = document.createElement("style");
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    })();

    cssPagedMedia.size = function (size) {
      cssPagedMedia("@page {size: " + size + "}");
    };
    cssPagedMedia.size("portrait");
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    if (
      this.props.isRange == "false" &&
      this.props.year != undefined &&
      this.props.month != undefined &&
      this.props.day != undefined
    ) {
      ReportStore.loadReportAnalysisWorkDebitCreditInOut(
        this.props.year,
        this.props.month,
        this.props.day,
        (result) => {
          this.setState({
            data: result.data,
            dataList: this.getPagination(result.data),
            report_title: "ไม่พบข้อมูล",
          });
        },
        () => {}
      );
    } else if (
      this.props.isRange == "true" &&
      this.props.startDate != undefined &&
      this.props.endDate != undefined
    ) {
      ReportStore.loadReportAnalysisWorkDebitCreditInOutRange(
        this.props.startDate,
        this.props.endDate,
        (result) => {
          this.setState({
            data: result.data,
            dataList: this.getPagination(result.data),
            report_title: "ไม่พบข้อมูล",
          });
        },
        () => {}
      );
    } else {
      this.setState({
        data: [],
        dataList: this.getPagination([]),
        report_title: "ไม่พบข้อมูล",
      });
    }
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getSummary(field) {
    let { data } = this.state;
    let total = 0;
    data.forEach((item, index) => {
      total +=
        item[field] === "" ||
        item[field] === null ||
        item[field] === undefined ||
        isNaN(item[field])
          ? 0
          : item[field] * 1;
    });
    return total;
  }

  getPercentSummary(field, field1) {
    let { data } = this.state;
    let total = 0;
    let total1 = 0;
    let sum = 0;
    data.forEach((item, index) => {
      total =
        item[field] === "" ||
        item[field] === null ||
        item[field] === undefined ||
        isNaN(item[field])
          ? 0
          : item[field] * 1;
      total1 =
        item[field1] === "" ||
        item[field1] === null ||
        item[field1] === undefined ||
        isNaN(item[field1])
          ? 0
          : item[field1] * 1;
      sum += this.getPercent(total, total1);
    });
    return sum;
  }

  getPagination(data) {
    let newData = [];
    let allData = [];
    let checkRow = 0;
    data.forEach(function (item, index) {
      if (checkRow < DEFAULT_ROW) checkRow++;
      newData.push(item);

      if (checkRow === DEFAULT_ROW - 1 || index === data.length - 1) {
        allData.push(newData);
        checkRow = 0;
        newData = [];
      }
    });

    return allData;
  }

  getPercent(cost, value) {
    let sum = 0;
    if (value > 0) sum = (cost / value) * 100;
    return sum;
  }

  renderRowData(data, indexs) {
    console.log("xxxxx", data);
    if (data.length == 0) {
      return (
        <tr>
          <td colSpan={11}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          <td className="text-center">{item.customer_payment_by}</td>
          <td className="text-center">{item.work_no}</td>
          <td className="text-center">{item.work_date}</td>
          <td className="text-center">{item.owner_name}</td>
          <td className="text-center">{item.car_registration_no}</td>
          <td className="text-center">{item.brand}</td>
          <td className="text-center">{item.model}</td>
          <td className="text-right">{item.excess}</td>
          <td className="text-right">{item.debit_wage}</td>
          <td className="text-right">{item.debit_part}</td>
          <td className="text-right">{item.credit_wage}</td>
          <td className="text-right">{item.credit_part}</td>
          <td className="text-right">{item.receiving_date}</td>
          <td className="text-right">{item.deleivering_date}</td>
        </tr>
      ));
    }
  }

  renderTable(item, index, length) {
    return (
      <table className="table table-print-report-analysis">
        <tbody>
          <tr>
            <th
              style={{ display: "none" }}
              className="text-center"
              colSpan={13}
            >
              รายงาน Job Cost Sheet {this.getDate()}
            </th>
          </tr>
          <tr>
            <th rowSpan="2" className="text-center" style={{ width: "90px" }}>
              ลำดับ
            </th>
            <th rowSpan="2" className="text-center" style={{ width: "90px" }}>
              ประเภทลูกค้า
            </th>
            <th rowSpan="2" className="text-center" style={{ width: "90px" }}>
              JOB NO.
            </th>
            <th rowSpan="2" className="text-center" style={{ width: "100px" }}>
              JOB_DATE
            </th>
            <th colSpan="4" className="text-center" style={{ width: "110px" }}>
              ข้อมูลรถยนต์
            </th>
            <th colSpan="3" className="text-center" style={{ width: "90px" }}>
              เงินสด
            </th>
            <th colSpan="2" className="text-center" style={{ width: "90px" }}>
              ประกัน
            </th>
            <th rowSpan="2" className="text-center" style={{ width: "120px" }}>
              รถเข้าซ่อม
            </th>
            <th rowSpan="2" className="text-center" style={{ width: "100px" }}>
              รถออก
            </th>
          </tr>
          <tr>
            <th className="text-center">ชื่อเจ้าของรถ</th>
            <th className="text-center">ทะเบียนรถ</th>
            <th className="text-center">ยี่ห้อรถ</th>
            <th className="text-center">รุ่นรถ</th>
            <th className="text-center">ค่าExcept</th>
            <th className="text-center">ค่าแรง</th>
            <th className="text-center">ค่าอะไหล่</th>
            <th className="text-center">ค่าแรง</th>
            <th className="text-center">ค่าอะไหล่</th>
          </tr>
          {this.renderRowData(item, index)}
        </tbody>
      </table>
    );
  }

  renderComponentPage(item, index, length) {
    return (
      <div className="font-print" key={index}>
        <header className="text-center">
          <h2>{this.props.title}</h2>
        </header>
        <div>{this.renderTable(item, index, length)}</div>
      </div>
    );
  }

  renderNoData() {
    return (
      <div className="font-print">
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    );
  }

  render() {
    let { loading, dataList } = this.state;
    if (dataList.length == 0) {
      return (
        <PrintPreview loading={loading} leftBarTitle={this.props.title}>
          {this.renderNoData()}
        </PrintPreview>
      );
    } else {
      return (
        <PrintPreview loading={loading} leftBarTitle={this.props.title}>
          {dataList.map((item, index) => {
            return this.renderComponentPage(item, index, dataList.length);
          })}
        </PrintPreview>
      );
    }
  }
}

PrintReportAnalysisWorkDebitCreditInOut.defaultProps = {
  title: "ตารางรายงาน สรุปงานซ่อมรถเข้า-ออก เงินสด/ประกัน",
  mode: "",
  workNo: "",
};
export default PrintReportAnalysisWorkDebitCreditInOut;



// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportAnalysisWorkDebitCreditInOut.js